import React from 'react';
import styled from 'styled-components';
import BarLoader from 'react-spinners/BarLoader';

const PlaceHolderOverlayWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  flex: 1;
  height: 100%;
  z-index: 100;
`;

const PlaceHolderWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  z-index: 100;
`;

const PreloaderWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

const PlaceHolder = ({ isLoading, br, overlay = true, width }) => {
  if (isLoading === false) return null;
  if (!overlay) {
    return (
      <PlaceHolderWrapper style={{ borderRadius: br, backgroundColor: '#C4C4C4' }}>
        <PreloaderWrapper>
          <BarLoader height={2} width={width ? width : 60} color="#ffffff" loading={true} />
        </PreloaderWrapper>
      </PlaceHolderWrapper>
    );
  }
  return (
    <PlaceHolderOverlayWrapper style={{ borderRadius: br, backgroundColor: '#C4C4C4' }}>
      <PreloaderWrapper>
        <BarLoader height={2} width={width ? width : 60} color="#ffffff" loading={true} />
      </PreloaderWrapper>
    </PlaceHolderOverlayWrapper>
  );
};

export default PlaceHolder;
